module.exports = __webpack_public_path__ + "static/media/eagle.dccf4eb2.jpg";